export const IconHeart: React.FC = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.6665 7.91662C1.66652 6.98929 1.94783 6.08377 2.47328 5.31967C2.99873 4.55557 3.7436 3.96883 4.60951 3.63695C5.47542 3.30507 6.42164 3.24366 7.32318 3.46082C8.22473 3.67799 9.03919 4.16352 9.659 4.85329C9.70266 4.89996 9.75544 4.93718 9.81407 4.96262C9.8727 4.98806 9.93593 5.00119 9.99984 5.00119C10.0637 5.00119 10.127 4.98806 10.1856 4.96262C10.2442 4.93718 10.297 4.89996 10.3407 4.85329C10.9585 4.15904 11.7732 3.66943 12.6762 3.44962C13.5792 3.22982 14.5277 3.29024 15.3956 3.62286C16.2634 3.95547 17.0093 4.5445 17.5341 5.31154C18.0589 6.07858 18.3376 6.98725 18.3332 7.91662C18.3332 9.82495 17.0832 11.25 15.8332 12.5L11.2565 16.9275C11.1012 17.1058 10.9098 17.249 10.6949 17.3477C10.48 17.4464 10.2465 17.4982 10.0101 17.4997C9.77362 17.5012 9.53954 17.4523 9.32341 17.3564C9.10728 17.2605 8.91403 17.1196 8.7565 16.9433L4.1665 12.5C2.9165 11.25 1.6665 9.83329 1.6665 7.91662Z"
      stroke="#E60076"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
